import createClient from 'openapi-fetch';
import type { paths } from '../../types/authSchema';
import baseUrl from '@pocapan/shared/utils/baseUrl';

export const authApiClient = createClient<paths>({ baseUrl: baseUrl() });

export type AuthAppName = 'pocapan' | 'bettie';

// 백엔드가 auth 요청마다 읽어 앱을 구분한다. 가입 안내 메일 발신 주체와
// Users::RecordAppUsageService 의 사용 앱 기록이 이 값에 걸려 있다.
export const AUTH_APP_NAME: AuthAppName = 'pocapan';

function asRecord(value: unknown): Record<string, unknown> | null {
  if (!value || typeof value !== 'object') return null;
  return value as Record<string, unknown>;
}

function findStringValue(target: Record<string, unknown>, key: string): string | null {
  const value = target[key];
  if (typeof value === 'string' && value.trim() !== '') {
    return value;
  }
  return null;
}

export function resolveAuthApiErrorMessage(error: unknown, fallbackMessage: string): string {
  const record = asRecord(error);
  if (!record) return fallbackMessage;

  const topLevelMessage = findStringValue(record, 'message');
  if (topLevelMessage) return topLevelMessage;

  const nestedError = asRecord(record.error);
  if (!nestedError) return fallbackMessage;

  return (
    findStringValue(nestedError, 'message') ||
    findStringValue(nestedError, 'detail') ||
    findStringValue(nestedError, 'errorMessage') ||
    fallbackMessage
  );
}
